import { krakenApi } from "../config/http-common";
import aditionalData from "../types/aditionalData.type";
import departamentData from "../types/departament.type";
import occupationData from "../types/occupation.type";

const cabecera = {
  headers: {
    'Accept': '*/*',
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    "Content-Type": "application/json"
 }
}

class AditionalDataService {

  getOccupations() {
    return krakenApi.get<Array<occupationData>>("/enrollment/otc/occupations",cabecera);
  }
  getDepartaments() {
    return krakenApi.get<Array<departamentData>>("/enrollment/otc/departments?countryId=PY",cabecera);
  }
  getCities(dpto: string) {
    return krakenApi.get<Array<departamentData>>(`/enrollment/otc/cities?departmentId=${dpto}`,cabecera);
  }
  nextChallenge(data: aditionalData) {
    return krakenApi.post<aditionalData>(`/enrolment/challengeRespond`, data);
  }
}

export default new AditionalDataService();